// Called on options widget load, this function will look for setup options and add the price to the text used in the POv1 customization
let checkForSetupOptions = function(form) {
  
  // Find all option titles in the widget
  let optionWidgetTitles = form.querySelectorAll('.bold_option_title');
  debugger;

  // For each title, find a setup fee and use that price in the setup fee text above the Add To Cart button.
  for (let i = 0; i < optionWidgetTitles.length; i++) {
    // Check to see if this option is a setup charge option.
    if (optionWidgetTitles[i].innerText.indexOf("Setup Charge") > -1) {
      let parent = optionWidgetTitles[i].closest('.bold_option');
      if (parent) {
        let price = parent.querySelector('.bold_option_value_price');

        // Handle the price text above the add to cart button
        if (price && price.innerText) {
          price = price.innerText;

          let feePriceElement = form.querySelector('.setup-fee-cost')
          if (feePriceElement) {
            feePriceElement.innerText = price;
          }
        }
        
        // Hide the checkbox input for this option
        let checkboxInput = parent.querySelector('input[class^="cb_"][type="checkbox"]');
        if (checkboxInput) {
          checkboxInput.style.display = "none";
          
          let optionLabel = checkboxInput.closest('label');
          if (optionLabel) {
            optionLabel.style.pointerEvents = "none";
          }
        }
      }
    }
  }
}


let setupChargeHandler = function(evt) {
  
  // Check if the event was triggered by a change in a checkbox option that has a name including "Setup Charge" and the action was enabling the input
  if (evt.data.option.publicName.indexOf("Setup Charge") > -1 && evt.data.option.type == "checkbox" && evt.data.value == "checked") {
    let optionElement = evt.data.source_input.closest('.bold_option');
    let quantityBoxContainer = optionElement.querySelector('.bold_option_value_quantity');

    // Hide the quantity input for this option, as we will only ever want it to be set to 1
    if (optionElement) {
      optionElement.style.display = "none";

      //Wait 5ms since the quantity box loads after the triggering event is emitted
      setTimeout(function(){
        let quantityBoxInput = quantityBoxContainer.querySelector('input[name="qty[]"]');
        if (quantityBoxInput) {
          quantityBoxInput.value = 1;
          quantityBoxInput.setAttribute("value", 1);
        }
      }, 5);
    }
    
    

    // This is for hiding/showing the setup fee message on the product form. Can be removed or disabled if desired
    let priceElement = evt.data.option_product.form.querySelector('.setup-fee-message');
    if (priceElement) {
      priceElement.style.display = "inherit";
    }
    // End setup fee hide/show code
  }

  // This is for hiding/showing the setup fee message on the product form. Can be removed or disabled if desired
  else if (evt.data.option.publicName.indexOf("Setup Charge") > -1 && evt.data.option.type == "checkbox") {
    let priceElement = evt.data.option_product.form.querySelector('.setup-fee-message');
    if (priceElement) {
      priceElement.style.display = "none";
    }
  }
  // End setup fee hide/show code
}





//Safety check in case of uninstall
if (window.BOLD && BOLD.options && BOLD.common && BOLD.common.eventEmitter) {

  //Set up listener for options widgets loading
  BOLD.common.eventEmitter.on("BOLD_OPTIONS_options_loaded", function(evt){
    //Grab the form from the event and call the handler function
    let optionForm = evt.data.option_product.form;
    checkForSetupOptions(optionForm);
  });

  //Set up listener for changes to options in order to handle setup charge options
  BOLD.common.eventEmitter.on("BOLD_OPTIONS_option_changed", setupChargeHandler);

  //Set up listener to change text on the cart page's subtotal element
  BOLD.common.eventEmitter.on("BOLD_OPTIONS_dom_loaded", function(){
    let subtotalPriceSpan = document.querySelector('span.Bold-theme-hook-DO-NOT-DELETE.bold_cart_total');

    if (subtotalPriceSpan && subtotalPriceSpan.nextSibling && subtotalPriceSpan.nextSibling.innerText) {
      subtotalPriceSpan.nextSibling.innerText = subtotalPriceSpan.nextSibling.innerText.replace("extras", "additional charges");
    }
  })

  //Set up listener to make sure text on cart page remains as we want it
  BOLD.common.eventEmitter.on("BOLD_COMMON_cart_prices_updated", function(){
    let subtotalPriceSpan = document.querySelector('span.Bold-theme-hook-DO-NOT-DELETE.bold_cart_total');

    if (subtotalPriceSpan && subtotalPriceSpan.nextSibling && subtotalPriceSpan.nextSibling.innerText) {
      subtotalPriceSpan.nextSibling.innerText = subtotalPriceSpan.nextSibling.innerText.replace("extras", "additional charges");
    }
  })


}